import PropTypes from "prop-types";
import { useMemo } from "react";
import { RadioButtonGroup } from "../../../../components/radio-button-group";
import {
  useLocaleProvider,
  useTranslate,
} from "../../../../context/locale-provider";

export const GraduationYearControl = ({
  selectedValue,
  minGraduationYear,
  onSelect,
  errorMessage,
}) => {
  const translate = useTranslate(useLocaleProvider());

  const graduationYears = useMemo(() => {
    const minYear = parseInt(minGraduationYear);

    const graduationYears = [];
    for (let i = minYear; i <= minYear + 5; i++) {
      graduationYears.push({
        value: i.toString(),
        label: i === minYear + 5 ? `${i.toString()}+` : i.toString(),
      });
    }
    return graduationYears;
  }, []);

  return (
    <RadioButtonGroup
      options={graduationYears}
      name="graduationYear"
      id="graduationYear"
      selectedValue={selectedValue}
      onSelect={onSelect}
      label={`${translate("sv_form_year_label")}:`}
      errorMessage={errorMessage}
      required
    />
  );
};

GraduationYearControl.propTypes = {
  selectedValue: PropTypes.string,
  minGraduationYear: PropTypes.string.isRequired,
  errorMessage: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
};

GraduationYearControl.defaultProps = {
  selectedValue: "",
  errorMessage: "",
};
